<template>
  <button
    class="gradient-button"
    :class="{red:red,white:white,gray:gray,widthStretch:widthStretch,disable:disable,flat:flat,smallButton:smallButton,wide:wide}"
    @click.stop="onclick()"
  >
    <router-link
      v-if="to"
      :to="to"
      class="gradient-button_content"
    >
      <i
        v-if="leadingIcon && !isloading"
        :class="leadingIcon"
        class="gradient-button_icon"
      />
      <p
        v-if="!isloading"
        class="gradient-button_text"
      >
        {{ textLabel }}
      </p>
      <LoadingAnimate v-else />
    </router-link>
    <div
      v-else
      class="gradient-button_content"
    >
      <i
        v-if="leadingIcon && !isloading"
        :class="leadingIcon"
        class="gradient-button_icon"
      />
      <p
        v-if="!isloading"
        class="gradient-button_text"
      >
        {{ textLabel }}
        <slot />
      </p>
      <LoadingAnimate v-else />
    </div>
  </button>
</template>
<script>
export default {
  name: "GradientButton",
  props: {
    gray: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: "",
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    white: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
    widthStretch: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    smallButton: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: "",
    },
  },
  methods: {
    onclick() {
      if (this.isloading || this.disable) return;
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped >
@import "@/assets/scss/component/gradient-button";
</style>